<div class="cancel-batch" *ngIf="preview">

  <div class="summary-cards">
    <div class="summary-card">
      <span class="label">Selecionadas</span>
      <span class="value">{{ preview.totals.requestedInvoices }}</span>
    </div>
    <div class="summary-card ok">
      <span class="label">Serão canceladas</span>
      <span class="value">{{ preview.totals.cancelableInvoices }}</span>
    </div>
    <div class="summary-card warn" *ngIf="preview.totals.cascadeInvoices > 0">
      <span class="label">Entram por rateio</span>
      <span class="value">{{ preview.totals.cascadeInvoices }}</span>
    </div>
    <div class="summary-card blocked" *ngIf="preview.totals.blockedInvoices > 0">
      <span class="label">Impedidas</span>
      <span class="value">{{ preview.totals.blockedInvoices }}</span>
    </div>
    <div class="summary-card">
      <span class="label">Pedidos cancelados</span>
      <span class="value">{{ preview.totals.ordersToCancel }}</span>
    </div>
    <div class="summary-card">
      <span class="label">Pedidos recriados</span>
      <span class="value">{{ preview.totals.ordersToRecreate }}</span>
    </div>
    <div class="summary-card">
      <span class="label">Valor cancelado</span>
      <span class="value">{{ preview.totals.cancelableTotalValue | number:'1.2-2' }}</span>
    </div>
  </div>

  <p-message severity="warn" styleClass="notice mb-3" *ngIf="preview.totals.cascadeInvoices > 0"
    [text]="preview.totals.cascadeInvoices + ' fatura(s) que você NÃO selecionou também serão canceladas, porque compartilham pedido rateado com as selecionadas. Elas estão marcadas como Rateio na lista abaixo.'">
  </p-message>

  <p-message severity="info" styleClass="notice mb-3"
    text="Os pedidos das faturas canceladas serão recriados (cópia), preservando o rateio, para que possam ser refaturados.">
  </p-message>

  <p-message severity="warn" styleClass="notice mb-3" *ngIf="tuitionOrdersCount > 0"
    [text]="tuitionNoticeText">
  </p-message>

  <div class="front-warnings mb-3" *ngIf="frontWarnings.length > 0">
    <p-message severity="warn" styleClass="notice mb-1" *ngFor="let warning of frontWarnings" [text]="warning">
    </p-message>
  </div>

  <p-panel styleClass="mb-3" [toggleable]="true"
    header="Faturas que serão canceladas ({{ preview.totals.cancelableInvoices }})">
    <div class="group" *ngFor="let group of cancelableGroups">
      <div class="group-header" *ngIf="isQuotaGroup(group)">
        <i class="pi pi-sitemap"></i>
        Rateio: {{ group.invoices.length }} faturas e {{ group.orders.length }} pedido(s) que só podem ser cancelados
        juntos
      </div>

      <p-table [value]="group.invoices" styleClass="easy-table" responsiveLayout="scroll">
        <ng-template pTemplate="header">
          <tr>
            <th>Fatura</th>
            <th>Cliente</th>
            <th class="text-center">Vencimento</th>
            <th class="text-right">Valor</th>
            <th class="text-center">Origem</th>
            <th class="text-center">Financeiro</th>
            <th class="text-center">Seleção</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-invoice>
          <tr [ngClass]="{'cascade-row': invoice.addedByQuotaCascade}">
            <td>{{ invoice.invoiceNumber }}</td>
            <td>{{ invoice.customerName }}</td>
            <td class="text-center">{{ invoice.dueDate | date:'dd/MM/yyyy' }}</td>
            <td class="text-right">{{ invoice.value | number:'1.2-2' }}</td>
            <td class="text-center">{{ invoice.origin }}</td>
            <td class="text-center">
              <span [pTooltip]="invoice.hasFinancesProgramacao
                ? 'A programação será cancelada no financeiro antes da fatura'
                : 'Fatura sem programação no financeiro'">
                {{ invoice.hasFinancesProgramacao ? 'Sim' : '—' }}
              </span>
            </td>
            <td class="text-center">
              <span class="tag cascade" *ngIf="invoice.addedByQuotaCascade">Rateio</span>
              <span class="tag selected" *ngIf="!invoice.addedByQuotaCascade">Selecionada</span>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <div class="orders-block">
        <div class="orders-title">
          Pedidos: {{ group.orders.length }} cancelado(s), {{ ordersToRecreate(group) }} recriado(s)
        </div>
        <p-table [value]="group.orders" styleClass="easy-table" responsiveLayout="scroll">
          <ng-template pTemplate="header">
            <tr>
              <th>Pedido</th>
              <th class="text-center">Data</th>
              <th class="text-center">Origem</th>
              <th class="text-right">Valor</th>
              <th class="text-center">Será recriado</th>
              <th>Rateio da cópia</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-order>
            <tr>
              <td>{{ order.orderNumber }}</td>
              <td class="text-center">{{ order.orderDate | date:'dd/MM/yyyy' }}</td>
              <td class="text-center">{{ order.origin }}</td>
              <td class="text-right">{{ order.value | number:'1.2-2' }}</td>
              <td class="text-center">
                <span class="tag ok" *ngIf="order.willBeCopied">Sim</span>
                <span class="tag muted" *ngIf="!order.willBeCopied"
                      [pTooltip]="notRecreatedReason(order)" tooltipPosition="left">
                  {{ isTuition(order) ? 'Não — mensalidade' : 'Não' }}
                </span>
              </td>
              <td>{{ quotasLabel(order.quotas) || '—' }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <div class="empty" *ngIf="cancelableGroups.length === 0">
      Nenhuma fatura da seleção pode ser cancelada.
    </div>
  </p-panel>

  <p-panel styleClass="mb-3 blocked-panel" [toggleable]="true" [collapsed]="false"
    *ngIf="blockedGroups.length > 0"
    header="Faturas que NÃO serão canceladas ({{ preview.totals.blockedInvoices }})">
    <div class="group" *ngFor="let group of blockedGroups">
      <div class="group-header blocked" *ngIf="isQuotaGroup(group)">
        <i class="pi pi-exclamation-triangle"></i>
        Rateio bloqueado: as {{ group.invoices.length }} faturas abaixo compartilham pedido, e uma delas tem
        impedimento — por isso nenhuma pode ser cancelada
      </div>
      <p-table [value]="group.invoices" styleClass="easy-table" responsiveLayout="scroll">
        <ng-template pTemplate="header">
          <tr>
            <th>Fatura</th>
            <th>Cliente</th>
            <th class="text-right">Valor</th>
            <th>Motivo</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-invoice>
          <tr>
            <td>{{ invoice.invoiceNumber || invoice.invoiceId }}</td>
            <td>{{ invoice.customerName || '—' }}</td>
            <td class="text-right">{{ invoice.value | number:'1.2-2' }}</td>
            <td>{{ blockReasonsLabel(invoice) }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </p-panel>

  <div class="confirmation">
    <p-message severity="error" styleClass="notice mb-2"
      text="Esta ação não pode ser desfeita. Para liberar o cancelamento, digite a palavra confirma no campo abaixo.">
    </p-message>
    <div class="confirmation-row">
      <input type="text" pInputText [(ngModel)]="confirmationText" [disabled]="!hasCancelable"
        placeholder="digite: confirma" autocomplete="off" class="confirmation-input">
      <button class="danger easymarine" type="button" [disabled]="!confirmationEnabled" (click)="confirm()">
        Cancelar {{ preview.totals.cancelableInvoices }} fatura(s)
      </button>
      <button class="primary easymarine" type="button" (click)="close()">Fechar</button>
    </div>
  </div>
</div>
